module.exports = __webpack_public_path__ + "img/1493713982.c9f3e0f7.jpg";